function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 37c9.389 0 17-7.611 17-17S29.389 3 20 3 3 10.611 3 20s7.611 17 17 17zm0 3c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z",
  fill: "params(fill) #00478C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.026 26.112l-3.992.071 4.914-4.914a.906.906 0 00.196-.998.922.922 0 00-.2-.298l-.434-.433a.92.92 0 00-1-.203.906.906 0 00-.296.199l-4.913 4.914.071-3.993a.917.917 0 00-.263-.661.925.925 0 00-.655-.278h-.591a.91.91 0 00-.844.562.91.91 0 00-.068.35l.02 7.162a.914.914 0 00.567.847c.111.046.23.07.35.07l7.167.026a.91.91 0 00.844-.562.91.91 0 00.068-.35v-.591a.926.926 0 00-.94-.92z",
  fill: "params(fill) #00478C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.944 14.888l3.992-.071-4.913 4.914a.908.908 0 00-.197.998.92.92 0 00.2.298l.434.433a.922.922 0 001 .203.905.905 0 00.296-.199l4.914-4.914-.072 3.993a.92.92 0 00.564.866.92.92 0 00.355.073h.59a.91.91 0 00.845-.562.912.912 0 00.068-.35L28 13.407a.914.914 0 00-.567-.847.917.917 0 00-.35-.07l-7.167-.025a.91.91 0 00-.844.561.91.91 0 00-.068.35l-.001.591a.924.924 0 00.584.854.924.924 0 00.357.066z",
  fill: "params(fill) #00478C"
});

function SvgMoreViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMoreViews;